enum InventoryOperationEnum {
    ADD = 1,
    SUBTRACT = 2,
    CYCLE_COUNT = 3,
}

export default InventoryOperationEnum;
